import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExitIcon } from "@/shared/icons";
import { Button, Confirm } from "@/shared/ui";
import useSignOut from "@/domains/account/hooks/useSignOut";

export default function AccountLogoutContainer() {
  const { t } = useTranslation("account");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { isPending, isCompleted, signOutHandler } = useSignOut();

  const closeConfirmModal = useCallback(() => {
    setShowConfirmModal(false);
  }, []);

  const openConfirmModal = useCallback(() => {
    setShowConfirmModal(true);
  }, []);

  useEffect(() => {
    if (isCompleted) {
      closeConfirmModal();
    }
  }, [isCompleted, closeConfirmModal]);

  return (
    <>
      <Button
        type="button"
        variant="soft"
        color="gray"
        className="w-full mt-2 h-11"
        onClick={openConfirmModal}
      >
        <ExitIcon size={16} className="mr-2.5" />
        {t("account.logout")}
      </Button>
      <Confirm
        open={showConfirmModal}
        onConfirm={signOutHandler}
        onCancel={closeConfirmModal}
        pending={isPending}
      >
        <div className="text-white text-16 font-bold text-center">Вы уверены?</div>
      </Confirm>
    </>
  );
}
